// Template 12 — "Flux Light" — Template 5's "Flux" layout (animated gradient
// borders, kinetic headline, glows) in a light theme with a premium magenta
// accent. Uses Template 5's `light` prop so the two stay perfectly in sync.
import Template5 from "./Template5";

export default function Template12(props) {
  return <Template5 {...props} light signature="#DB2777" signature2="#0EA5E9" />;
}
